import "./LovejoyServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import Lovejoy from "./sections/Lovejoy";
import ServicesGrid from "./sections/ServicesGrid";
import PlumbingIssues from "./sections/PlumbingIssues";
import LovejoyFaq from "./sections/LovejoyFaq";
import LovejoyClosing from "./sections/LovejoyClosing";
import Footer from "@/reusable_sections/Footer";
export default function LovejoyServiceAreaPage() {
  return <div>
      <Header />
      <Lovejoy />
      <ServicesGrid />
      <PlumbingIssues />
      <LovejoyFaq />
      <LovejoyClosing />
      <Footer />
    </div>;
}